module.exports = __webpack_public_path__ + "static/media/poster_2.f377c70e.png";